import moment from "moment";
import format from "string-template";
import { DATE_FORMAT, REGEX_EXPS } from "utils/constants";
import { createContractNumberValidation } from "utils/helpers/validations";
import * as yup from "yup";

const validator = (
  messages,
  { deltaRia, deltaStart, deltaEnd, deltaEndRia },
) => {
  const requiredString = yup
    .string()
    .typeError(messages.REQUIRED)
    .required(messages.REQUIRED);
  const contractNumber = createContractNumberValidation(messages, REGEX_EXPS);
  return yup.object().shape({
    contract: yup.mixed().when("ria", {
      is: (ria) => {
        return ria;
      },
      then: yup.object().shape({
        issuanceDate: yup
          .date()
          .typeError(messages.REQUIRED)
          .min(
            moment().startOf("day").add(deltaRia, "days"),
            format(messages.MIN_DATE, {
              date: moment().add(deltaRia, "days").format(DATE_FORMAT),
            }),
          )

          .required(messages.REQUIRED),
      }),
      otherwise: yup.object().shape({
        issuanceDate: yup
          .date()
          .typeError(messages.REQUIRED)
          .min(
            moment().startOf("day").add(deltaStart, "days"),
            format(messages.MIN_DATE, {
              date: moment().add(deltaStart, "days").format(DATE_FORMAT),
            }),
          )
          .required(messages.REQUIRED),
      }),
    }),
    terminationRequest: yup.mixed().when("fields.selfOccupation", {
      is: false,
      then: yup.object().shape({
        contractNumber: contractNumber,
        address: requiredString,
        brokerageMandate: yup.object().shape({
          currentCompany: contractNumber,
        }),
      }),
      otherwise: yup.object().nullable().notRequired(),
    }),
  });
};

export default validator;
